import React from 'react';
import { connect } from 'react-redux';

import SelectField from 'eventbrite_design_system/inputField/SelectField';

import { setExperimentOverride } from '../actions/admin';

const parseExperimentsForSelect = (experiments) =>
    Object.keys(experiments).map((experimentName) => ({
        value: experimentName,
        display: experimentName,
    }));
const getSelectValues = (experiments) => [
    { value: 'none', display: 'No experiment override' },
    ...parseExperimentsForSelect(experiments),
];

const AdminSearchSubHeader = (props) => {
    return props.isStaff ? (
        <div className="search-admin-subheader eds-bg-color--grey-200">
            <div className="eds-text-color--primary-brand eds-text-weight--heavy eds-text-bl eds-align--center">
                Staff-only debug tool
            </div>
            <div className="eds-align--center">
                <SelectField
                    label="Experiment"
                    values={getSelectValues(props.experiments)}
                    value={props.experimentOverride.experimentName}
                    onChange={(experimentName) =>
                        props.setExperimentOverride({
                            experimentName,
                            variant: props.experimentOverride.variant,
                        })
                    }
                />
                <div className="eds-l-mar-left-4">
                    <SelectField
                        style="basic"
                        label="Variant"
                        values={[
                            { value: 'A', display: 'A' },
                            { value: 'B', display: 'B' },
                            { value: 'C', display: 'C' },
                            { value: 'D', display: 'D' },
                        ]}
                        value={props.experimentOverride.variant}
                        onChange={(variant) =>
                            props.setExperimentOverride({
                                experimentName:
                                    props.experimentOverride.experimentName,
                                variant,
                            })
                        }
                    />
                </div>
            </div>
        </div>
    ) : null;
};

const _mapStateToProps = (state) => ({
    experiments: state.app.experiments,
    experimentOverride: state.admin.experimentOverride,
    isStaff: state.user.isStaff,
});

const _mapDispatchToProps = (dispatch) => ({
    setExperimentOverride: (...args) =>
        dispatch(setExperimentOverride(...args)),
});

export default connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(AdminSearchSubHeader);
